import { useEffect, useState } from "react";

export default function HeroCarousel({ images = [], interval = 5000 }) {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (images.length <= 1) return;
    const t = setInterval(() => {
      setIdx((i) => (i + 1) % images.length);
    }, interval);
    return () => clearInterval(t);
  }, [images.length, interval]);

  if (!images.length) return null;

  return (
    <div className="absolute inset-0 overflow-hidden bg-[#0A0908]" data-testid="hero-carousel">
      {images.map((src, i) => (
        <div
          key={src + i}
          className="absolute inset-0 transition-opacity duration-[1600ms] ease-in-out"
          style={{ opacity: i === idx ? 1 : 0 }}
        >
          <img
            src={src}
            alt=""
            className="w-full h-full object-cover"
            style={{
              animation: i === idx ? "tt-ken-burns 8s ease-out both" : "none",
              filter: "brightness(0.55) contrast(1.1) saturate(0.9)",
            }}
          />
        </div>
      ))}

      {/* Progress bar */}
      {images.length > 1 && (
        <div className="absolute bottom-8 right-8 lg:bottom-12 lg:right-12 z-20 flex items-center gap-3">
          <span className="overline text-[#FAF9F6]/60">
            {String(idx + 1).padStart(2, "0")} · {String(images.length).padStart(2, "0")}
          </span>
          <div className="w-24 h-px bg-[#FAF9F6]/20 relative overflow-hidden">
            <div
              key={idx}
              className="absolute top-0 left-0 h-full bg-[#C9A961]"
              style={{ animation: `tt-progress ${interval}ms linear` }}
            />
          </div>
        </div>
      )}
    </div>
  );
}
